<template>
  <article class="h-full w-full lg:max-w-2xl">
    <div
      class="w-full h-64 bg-full mb-8 bg-white-30"
      :style="{ backgroundImage: `url('${image}')` }"
      role="img"
      aria-label="image.alt"
    />

    <div
      class="tiny-mce p-x pb-8 text-body lg:text-white lg:px-0"
      v-html="wysiwygFilter(post.body)"
    />
  </article>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { wysiwygFilter } from '@/mixins'

export default {
  name: 'Article',

  mixins: [wysiwygFilter],

  props: {
    post: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState(['touch', 'mobile']),
    ...mapGetters([]),

    image() {
      const image = this.post.image

      if (image && this.mobile) {
        return image.sizes.medium
      } else if (image) {
        return image.sizes.large
      }

      return false
    }
  }
}
</script>
